import { FC } from 'react';

import {
  getLeadStageColor,
  getLeadStatusColor,
  labelForLeadStage,
  labelForLeadStatus,
} from '../../utils/leadsAdmin';

type LeadStageBadgeProps = {
  value?: string;
};

/** Colored pill badge for a lead pipeline stage. */
export const LeadStageBadge: FC<LeadStageBadgeProps> = ({ value }) => {
  const colors = getLeadStageColor(value);
  const label = labelForLeadStage(value);

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-open-sans text-[12px] font-medium"
      style={{ color: colors.primary, backgroundColor: colors.background }}
    >
      <span
        className="inline-flex h-3 w-3 items-center justify-center rounded-full"
        style={{ backgroundColor: colors.background }}
      >
        <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: colors.primary }} />
      </span>
      {label}
    </span>
  );
};

type LeadStatusBadgeProps = {
  value?: string;
};

/** Colored pill badge for a lead status. */
export const LeadStatusBadge: FC<LeadStatusBadgeProps> = ({ value }) => {
  const colors = getLeadStatusColor(value);
  const label = labelForLeadStatus(value);

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 font-open-sans text-[12px] font-medium"
      style={{ color: colors.primary, backgroundColor: colors.background }}
    >
      <span
        className="inline-flex h-3 w-3 items-center justify-center rounded-full"
        style={{ backgroundColor: colors.background }}
      >
        <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: colors.primary }} />
      </span>
      {label}
    </span>
  );
};

type LeadFlagBadgeTone = 'default' | 'pawdit' | 'referral';

type LeadFlagBadgeProps = {
  label: string;
  tone?: LeadFlagBadgeTone;
};

const LEAD_FLAG_BADGE_CLASS: Record<LeadFlagBadgeTone, string> = {
  default:
    'ml-2 inline-flex rounded-full bg-[#FFF4E5] px-2 py-0.5 font-open-sans text-[11px] font-semibold uppercase tracking-wide text-[#B45309]',
  pawdit:
    'ml-2 inline-flex rounded-full bg-[#E8F6FA] px-2 py-0.5 font-open-sans text-[11px] font-semibold uppercase tracking-wide text-[#013847]',
  referral:
    'ml-2 inline-flex rounded-full bg-primary-tint px-2 py-0.5 font-open-sans text-[11px] font-semibold uppercase tracking-wide text-primary-100',
};

/** Small flag badge for test, draft, reply, or Pawdit demo leads. */
export const LeadFlagBadge: FC<LeadFlagBadgeProps> = ({ label, tone = 'default' }) => (
  <span className={LEAD_FLAG_BADGE_CLASS[tone]}>{label}</span>
);
